import { ConcreteEncodable } from "./ConcreteEncodable";

import { QueryRuleImplEncoder } from "../../encoder/QueryRuleImplEncoder";

import * as CubiqTS from "../../index";
import { QueryRule } from "../QueryRule";

export class QueryRuleImpl extends ConcreteEncodable implements QueryRule {
  public static enType: string = "com.bcdfx.model.query.QueryRuleImpl";

  /*FID=1*/
  public field: string;
  /*FID=2*/
  public operator: CubiqTS.Operator;
  /*FID=3*/
  public values: Array<string> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = QueryRuleImplEncoder.Instance;
    this.setEncodableType(QueryRuleImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "QueryRuleImpl[" +
      "field=" +
      this.field +
      "operator=" +
      this.operator +
      "values=" +
      this.values +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
